/* =============================================
   RVRN VIP SPECIAL PATHS — JS (deferred)
   Checkout guide step tabs: switch active tab + caption
   DOM contract: button[data-step][data-caption-title][data-caption-text]
                 + [data-caption-step] / [data-caption-title] / [data-caption-text]
   ============================================= */
;(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.rvrn-vip-special-paths').forEach(function (section) {
      var tabs = section.querySelectorAll('.rvrn-vip-special-paths__checkout-steps button[data-step]');
      if (!tabs.length) return;

      var captionStep = section.querySelector('.rvrn-vip-special-paths__checkout-caption [data-caption-step]');
      var captionTitle = section.querySelector('.rvrn-vip-special-paths__checkout-caption [data-caption-title]');
      var captionText = section.querySelector('.rvrn-vip-special-paths__checkout-caption [data-caption-text]');

      function padStep(step) {
        var n = parseInt(step, 10);
        if (isNaN(n)) return step || '';
        return n < 10 ? 'STEP 0' + n : 'STEP ' + n;
      }

      function activate(tab) {
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        var step = tab.getAttribute('data-step') || '';
        var title = tab.getAttribute('data-caption-title') || '';
        var text = tab.getAttribute('data-caption-text') || '';

        if (captionStep) captionStep.textContent = padStep(step);
        if (captionTitle) captionTitle.textContent = title;
        if (captionText) captionText.textContent = text;
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activate(tab);
        });
      });

      /* ---- Click image to open lightbox (zoom) ---- */
      var mediaWraps = section.querySelectorAll(
        '.rvrn-vip-special-paths__checkout-image, .rvrn-vip-special-paths__cf-preview'
      );

      // Build a single lightbox element per section
      var lightbox = document.createElement('div');
      lightbox.className = 'rvrn-vip-special-paths__lightbox';
      lightbox.setAttribute('role', 'dialog');
      lightbox.setAttribute('aria-hidden', 'true');
      var closeBtn = document.createElement('button');
      closeBtn.className = 'rvrn-vip-special-paths__lightbox-close';
      closeBtn.setAttribute('aria-label', 'Close');
      closeBtn.textContent = '×';
      lightbox.appendChild(closeBtn);
      lightbox._media = null;
      section.appendChild(lightbox);

      function openLightbox(src, isVideo) {
        var media;
        if (isVideo) {
          media = document.createElement('video');
          media.src = src;
          media.controls = true;
          media.autoplay = true;
          media.loop = true;
          media.muted = true;
        } else {
          media = document.createElement('img');
          media.src = src;
          media.alt = '';
        }
        if (lightbox._media) lightbox.removeChild(lightbox._media);
        lightbox.insertBefore(media, closeBtn);
        lightbox._media = media;
        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
      }

      function closeLightbox() {
        lightbox.classList.remove('is-open');
        lightbox.setAttribute('aria-hidden', 'true');
        if (lightbox._media) {
          lightbox.removeChild(lightbox._media);
          lightbox._media = null;
        }
      }

      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeLightbox();
      });
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && lightbox.classList.contains('is-open')) closeLightbox();
      });

      mediaWraps.forEach(function (wrap) {
        wrap.addEventListener('click', function (e) {
          // Don't trigger when clicking the CTA / caption links
          if (e.target.closest('a, button')) return;
          var el = wrap.querySelector('img, video');
          if (!el) return;
          var zoomSrc = el.getAttribute('data-zoom-src') || el.currentSrc || el.src;
          openLightbox(zoomSrc, el.tagName === 'VIDEO');
        });
      });
    });
  });
})();
